import { isCatSegmentation, SEGMENTS_SLUGIFIED_FILTER_MAP } from 'constants/segmentation';
import { CollectionPropTypes } from 'modules/collection/types/CollectionPropTypes';
import { useMemo, useState } from 'react';
import { generateInputFromSegmentationIds, mergeDynamicInput } from 'utils/api/smartCollection';
import { omitNullableHandler } from 'utils/type-helper';

type PropTypes = CollectionPropTypes;

interface Input {
  providerProps?: PropTypes;
  isCat?: boolean;
}

/**
 * Override props based on filter tags
 */
const useOverrideProps = ({ providerProps, isCat = false }: Input) => {
  const [filterTags, setFilterTags] = useState<Array<string>>([]);

  /**
   * When dynamic collection api is used and segmentation related filters are
   */
  const additionalInput = useMemo(() => {
    const segmentationIds = filterTags
      .map((tag) => SEGMENTS_SLUGIFIED_FILTER_MAP[tag])
      .flat()
      // Keep only segmentations that match the pet type
      .filter((v) => isCatSegmentation(v) === isCat)
      .filter(omitNullableHandler);
    return generateInputFromSegmentationIds({ segmentationIds });
  }, [filterTags, isCat]);

  /**
   * When additionalInput is available override values
   */
  const providerPropsOverride = useMemo(() => {
    if (
      providerProps &&
      additionalInput &&
      providerProps.smartCollectionInput &&
      // ignore pet type
      Object.values(additionalInput).flat().length > 1
    ) {
      return {
        ...providerProps,
        smartCollectionInput: mergeDynamicInput({
          target: providerProps.smartCollectionInput,
          source: additionalInput,
        }),
      };
    }
    return providerProps;
  }, [additionalInput, providerProps]);

  return {
    providerPropsOverride,
    setFilterTags,
  };
};

export default useOverrideProps;
